import React from 'react';
import './StepsExplainer.css'; // Use the same CSS as before

const StepsExplainer = ({ communityTitle }) => (
  <div className="steps-container-vertical">
    <div className="step-card">
      <div className="step-number">1</div>
      <div className="step-content">
        <h3>{communityTitle ? "Join this group" : "Join a group"}</h3>
        <p>
          {communityTitle
            ? `Become part of our ${communityTitle} community`
            : "Become part of one of many distinct communities"}
        </p>
      </div>
    </div>
    <div className="vertical-arrow">↓</div>
    <div className="step-card">
      <div className="step-number">2</div>
      <div className="step-content">
        <h3>Get suggested matches</h3>
        <p>
          {communityTitle
            ? "We'll show you compatible members"
            : "We'll suggest people in a group to connect with"}
        </p>
      </div>
    </div>
    <div className="vertical-arrow">↓</div>
    <div className="step-card">
      <div className="step-number">3</div>
      <div className="step-content">
        <h3>Connect & chat</h3>
        <p>
          {communityTitle
            ? "When interest is mutual, we'll introduce you"
            : "When interest is mutual, we’ll introduce you"}
        </p>
      </div>
    </div>
  </div>
);

export default StepsExplainer;


        // step1={`Join ${sanitizedCommunity.title} and describe who you want to connect with.`}
        // step2={`We'll suggest people in ${sanitizedCommunity.title}.`}
        // step3="If you both agree, we introduce you over messenger."